import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';
const Ctx = createContext();
export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(localStorage.getItem('admin_token'));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`)
        .then(r => { if(r.data.user.role==='super_admin') setUser(r.data.user); else logout(); })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else setLoading(false);
  }, [token]);
  const login = async (phone, password) => {
    const r = await axios.post(`${API}/auth/login`, { phone, password });
    if (r.data.user.role !== 'super_admin') throw new Error('ليس حساب أدمن');
    localStorage.setItem('admin_token', r.data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${r.data.token}`;
    setToken(r.data.token); setUser(r.data.user);
  };
  const logout = () => {
    localStorage.removeItem('admin_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null); setUser(null);
  };
  return <Ctx.Provider value={{ user, token, loading, login, logout }}>{children}</Ctx.Provider>;
};
export const useAuth = () => useContext(Ctx);
